var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-textarea',{attrs:{"value":_vm.value,"rows":"3","max-rows":"6","readonly":_vm.readonly},on:{"input":function($event){return _vm.commitValue($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }